import React from 'react';
import styled from 'styled-components';
import Badge from '@material-ui/core/Badge';
import {
    MemberOnline,
    MemberNoLocationFor5Mins,
    MemberNoLocationFor24Hours,
    MemberIncognito,
    MemberNegativePermissions, BatteryLevel, MemberPendingInvite
} from '../../UI/Icons';
import {setActiveUser} from './dashboardSlice';
import {useDispatch, useSelector} from 'react-redux';
import {fontSize} from '../../mixins';
import {selectPaymentStatus, setShowInviteModal, setShowPaywall} from '../onboarding/onboardingSlice';
import {setNote} from '../note/noteSlice';
import {setPopupShow} from '../map/mapSlice';

const StyledBattery = styled.div`
  width: 50px;
  margin-left: -40px;
  margin-top: 7px;
  padding: 1px 6px;
  background: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 24px rgba(58, 79, 79, 0.12);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  
  span {
  ${fontSize(9)};
  line-height: 16px;
  letter-spacing: -0.217059px;
  color: #6E6E6E;
}
`



const getBadgeIcon = (appStatus, locationStatus, batteryLevel, showBatteryLevel, pending) => {
    if (pending) {
        return  <MemberPendingInvite/>;
    }

    if (appStatus === 'PERMISSIONS') {
        return  <MemberNegativePermissions/>;
    }

    if (appStatus === 'INCOGNITO') {
        return <MemberIncognito/>;
    }

    if (appStatus === 'PENDING') {
        return <MemberPendingInvite/>;
    }

    if (locationStatus === 'ONLINE') {

        if (showBatteryLevel) {
            return <StyledBattery>
                <BatteryLevel level={batteryLevel}/>
                <span>{batteryLevel}%</span>
            </StyledBattery>
        }

        return <MemberOnline/>;
    }

    if (locationStatus === 'OLDER_THAN_FIVE_MINS') {
        return <MemberNoLocationFor5Mins/>;
    }

    if (locationStatus === 'OLDER_THAN_24H') {
        return <MemberNoLocationFor24Hours/>;
    }
}


const UserBadge = ({children, userID, appStatus, locationStatus, batteryLevel, showBatteryLevel, isFakeUser, pending}) => {
    const dispatch = useDispatch();
    const paymentStatus = useSelector(selectPaymentStatus);

    const icon = getBadgeIcon(appStatus, locationStatus, batteryLevel, showBatteryLevel, pending);

    const onFakeMarkerClick = () => {
        if (paymentStatus) {
            return dispatch(setShowInviteModal(true));
        }

        return dispatch(setShowPaywall(true));
    }

    const onClick = (id) => () => {
        if (pending) {
            return dispatch(setNote({show: true, text: 'Waiting for the user to join the circle'}));
        }

        if (isFakeUser) {
            return onFakeMarkerClick();
        }
        dispatch(setPopupShow(true))
        dispatch(setActiveUser(id));
    }

    return (
        <Badge
            overlap="circle"
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            alt={userID}
            badgeContent={icon}
            onClick={onClick(userID)}
        >
            {children}
        </Badge>
    );
};

export default UserBadge;